import { AxiosInstance } from 'axios';
import { CreateUserVerificationInput, ClaimUserVerificationInput } from './inputs';
import { UserVerificationRef } from './refs';

export default class UserVerification {
    private basePath = '/api/user-verification';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Create new user verification
    create = async (input: CreateUserVerificationInput): Promise<UserVerificationRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Claim user verification and verify user
    claimVerification = async (id: ID, input: ClaimUserVerificationInput): Promise<UserVerificationRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/claim`, input);
        return data;
    };
}
